import React, { useMemo } from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import { CAPABILITIES_LIST } from './constants/capabilities-list'
import {useIsMobile} from "~helpers/hooks/useIsMobile";

interface ICapabilityItem {
  text: string,
  icon: string
}

interface ICapability {
  text: string,
  color: string,
  list: ICapabilityItem[]
}

const TelephonyCapabilities = () => {
  const isMobile = useIsMobile();

  const renderCapability = (item: ICapability) => {
    return (
      <Styled.Capability>
        <Styled.CapabilityHeader color={item.color}>{item.text}</Styled.CapabilityHeader>
        <Styled.CapabilityBody>
          <Styled.CapabilityList>
            {
              item.list.map((itm:ICapabilityItem) => (
                <Styled.CapabilityItem>
                  {
                    itm.icon &&
                    <Styled.CapabilityItemIcon>
                      <img src={`${process.env.PUBLIC_DIR}/images/index_page/capabilities/${itm.icon}`} alt={itm.icon} />
                    </Styled.CapabilityItemIcon>
                  }
                  <Styled.CapabilityItemText>{itm.text}</Styled.CapabilityItemText>
                </Styled.CapabilityItem>
              ))
            }
          </Styled.CapabilityList>
        </Styled.CapabilityBody>
      </Styled.Capability>
    )
  }

  return (
    <Screen
      id='possibilities'
      title={
        !isMobile
          ? <span><StyledScreen.GreenText>Возможности</StyledScreen.GreenText> телефонии для разных отделов</span>
          : <span><StyledScreen.GreenText>Возможности</StyledScreen.GreenText><br />телефонии для разных<br />отделов</span>
      }
      bottomLine={true}
    >
      <Styled.CapabilitiesContainer>
        <Styled.Row>
        {
          CAPABILITIES_LIST.map((item: ICapability) => renderCapability(item))
        }
        </Styled.Row>
        {/*{*/}
        {/*  preparedCapabilitiesList.map((row: []) => (*/}
        {/*    <Styled.Row>*/}
        {/*      {*/}
        {/*        row.map((item: ICapability) => renderCapability(item))*/}
        {/*      }*/}
        {/*    </Styled.Row>*/}
        {/*  ))*/}
        {/*}*/}
      </Styled.CapabilitiesContainer>
    </Screen>
  )
}

export { TelephonyCapabilities }
